import { takeEvery, put, call } from "redux-saga/effects";

//Account Redux states
import { REGISTER_USER } from "./actionTypes";
import { registerUserSuccessful, registerUserFailed } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeRegister,
  postJwtRegister,
} from "../../../helpers/fakebackend_helper";
// initialize relavant method of both Auth
const fireBaseBackend = getFirebaseBackend();

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user } }) {
  console.log("SAGA REGISTER USER FIRE, USER : ", user);

  try {
    yield put(registerUserSuccessful(user));
  } catch (error) {
    yield put(registerUserFailed(errors));
  }
}

function* accountSaga() {
  // yield takeEvery(REGISTER_USER, registerUser);
}

export default accountSaga;
